// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"370d1fdb4ff3db63","4443":"dd19a6863df21303"}[chunkId] + ".css";
};